import React, { FC } from 'react'
import styles from './Badge.module.scss'
import cx from 'classnames'

export const TONES = ['info', 'neutral', 'positive', 'caution', 'critical', 'outline'] as const
export const SIZES = ['default', 'small'] as const

export type Tone = typeof TONES[number]
type Size = typeof SIZES[number]

type BadgeProps = {
  tone?: Tone
  size?: Size
  color?: string
}

export const Badge: FC<BadgeProps> = ({
  children,
  tone = 'neutral',
  size = 'default',
  color,
  ...rest
}) => {
  const badgeStyles = cx({
    [styles.badge]: true,
    [styles[tone]]: !color && tone,
    [styles[size]]: size,
  })

  const style = color ? { backgroundColor: color } : {}

  return (
    <span className={badgeStyles} {...rest} style={style}>
      {children}
    </span>
  )
}

Badge.displayName = 'Badge'
